import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WellsApiService } from '~/services/wells-api.service';

@Component({
    selector: 'app-bu-selection',
    templateUrl: './bu-selection.component.html',
    styleUrls: ['./bu-selection.component.scss'],
    standalone: false
})
export class BuSelectionComponent implements OnInit {
    // Step tracking
    public showAssetSelection: boolean = true;
    public showBuSelection: boolean = false;
    public selectedAsset: string = '';

    constructor(private router: Router, private wellsApiService: WellsApiService) {}

    ngOnInit() {
        // Clear any existing selection when landing on this page
        this.wellsApiService.clearSelectedBU();
    }

    /**
     * Handle asset selection and show BU selection
     * - Shale & Tight → RBU
     * - Conventional → ABU
     */
    public selectAsset(asset: string): void {
        if (asset === 'deepwater' || asset === 'exploration') {
            return; // Do nothing for disabled assets
        }
        
        this.selectedAsset = asset;
        this.showAssetSelection = false;
        this.showBuSelection = true;
    }

    /**
     * Go back from BU selection to Asset selection
     */
    public goBack(): void {
        this.showBuSelection = false;
        this.showAssetSelection = true;
        this.selectedAsset = '';
    }

    /**
     * Handle BU selection for the selected asset
     */
    public selectBU(bu: string): void {
        // Store selected BU in sessionStorage
        this.wellsApiService.setSelectedBU(bu);
        
        // Navigate to wells dashboard
        this.router.navigate(['/wells']);
    }

    /**
     * Get BU options based on selected asset
     */
    public getBUOptions(): Array<{code: string, name: string}> {
        switch(this.selectedAsset) {
            case 'shale':
                return [
                    { code: 'RBU', name: 'WYOMING' }
                ];
            case 'conventional':
                return [
                    { code: 'ABU', name: 'Onshore - Australia Business Unit' }
                ];
            default:
                return [];
        }
    }

    /**
     * Get asset display name
     */
    public getAssetDisplayName(): string {
        switch(this.selectedAsset) {
            case 'shale':
                return 'Shale & Tight (S&T)';
            case 'conventional':
                return 'Conventional';
            default:
                return '';
        }
    }
}
